module.exports = __webpack_public_path__ + "img/keder_moosgruen_ral6005.61fcf51a.jpg";